module.exports = __webpack_public_path__ + "img/scoring.9a8280e6.png";